import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Kitchen from '../components/Kitchen/Kitchen'

function KitchenRoomPage() {
  return (
    <>
    <Navbar/>
    <Kitchen/>
    </>
  )
}

export default KitchenRoomPage
